const bn = {
    nav: {
      home: "হোম",
      browse: "বিবাহ ব্রাউজ করুন",
      dashboard: "ড্যাশবোর্ড",
      messages: "বার্তা",
      profile: "প্রোফাইল",
      login: "লগইন",
      register: "নিবন্ধন",
      logout: "লগআউট",
      admin: "অ্যাডমিন",
      faq: "প্রশ্নোত্তর",
      about: "আমাদের সম্পর্কে",
      contact: "যোগাযোগ",
      pricing: "মূল্য",
      howItWorks: "এটি কিভাবে কাজ করে",
    },
    auth: {
      login: {
        title: "স্বাগতম",
        email: "ইমেল",
        password: "পাসওয়ার্ড",
        button: "লগইন",
        noAccount: "অ্যাকাউন্ট নেই?",
        register: "এখনই নিবন্ধন করুন",
      },
      register: {
        title: "অ্যাকাউন্ট তৈরি করুন",
        name: "পুরো নাম",
        email: "ইমেল",
        password: "পাসওয়ার্ড",
        role: "আমি চাই...",
        roleHost: "বিবাহ আয়োজন করতে",
        roleGuest: "বিবাহে যোগ দিতে",
        terms: "আমি শর্তাবলী ও গোপনীয়তা নীতি মেনে নিচ্ছি",
        button: "নিবন্ধন",
        hasAccount: "ইতিমধ্যে নিবন্ধিত?",
        login: "এখনই লগইন করুন",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "লোড হচ্ছে...",
      error: "একটি ত্রুটি ঘটেছে",
      success: "সফল",
      save: "সংরক্ষণ",
      cancel: "বাতিল",
      delete: "মুছুন",
      edit: "সম্পাদনা",
      back: "পিছনে",
      next: "পরবর্তী",
      language: "ভাষা",
      currency: "মুদ্রা",
      search: "অনুসন্ধান",
      filter: "ফিল্টার",
      all: "সব",
      none: "কোনোটি নয়",
      yes: "হ্যাঁ",
      no: "না",
    },
    footer: {
      about: "সম্পর্কে",
      privacy: "গোপনীয়তা",
      terms: "শর্তাবলী",
      contact: "যোগাযোগ",
      copyright: "© 2024 WEDVAYA. সর্বস্বত্ব সংরক্ষিত।",
    },
  };

export default bn;
